import { create } from 'zustand'
import type { SalesStorePickerItem } from '@/features/sales/types'
import type { VisitRouteResult } from '@/features/visitplan/tmapTypes'

export const VISIT_ROUTE_MAX_STOPS = 10

interface VisitRouteState {
  input: string
  selected: SalesStorePickerItem[]
  pending: boolean
  error: string | null
  route: VisitRouteResult | null
  fullscreenOpen: boolean
  setInput: (input: string) => void
  setPending: (pending: boolean) => void
  setError: (error: string | null) => void
  setRoute: (route: VisitRouteResult | null) => void
  setFullscreenOpen: (fullscreenOpen: boolean) => void
  setSelectedStores: (stores: SalesStorePickerItem[]) => void
  toggleStore: (store: SalesStorePickerItem) => void
  clearSelected: () => void
}

export const useVisitRouteStore = create<VisitRouteState>((set) => ({
  input: '',
  selected: [],
  pending: false,
  error: null,
  route: null,
  fullscreenOpen: false,
  setInput: (input) => set({ input }),
  setPending: (pending) => set({ pending }),
  setError: (error) => set({ error }),
  setRoute: (route) => set({ route }),
  setFullscreenOpen: (fullscreenOpen) => set({ fullscreenOpen }),
  setSelectedStores: (selected) => set({ input: '', selected, route: null, error: null }),
  clearSelected: () => set({ input: '', selected: [], route: null, error: null, fullscreenOpen: false }),
  toggleStore: (store) =>
    set((state) => {
      if (state.selected.some((item) => item.storeCd === store.storeCd)) {
        return {
          selected: state.selected.filter((item) => item.storeCd !== store.storeCd),
          route: null,
          error: null,
        }
      }

      if (state.selected.length >= VISIT_ROUTE_MAX_STOPS) {
        return { error: `최대 ${VISIT_ROUTE_MAX_STOPS}개 매장까지 선택할 수 있습니다.` }
      }

      return { selected: [...state.selected, store], route: null, error: null }
    }),
}))
